import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { Endpoints } from "services/api";
import errorHandler from "common/errorHandler";
import * as actions from "./actions";

// No tenantid header — the tenant is determined server-side from the auth-token claims.

const definitionPath = (definitionId) => `${Endpoints.duplicates}/api/v1/dataobjects/duplicates/definitions/${definitionId}`;

export function* getDuplicateSearchSettingsRequest(api, action) {
    const { definitionId } = action.params;
    try {
        const result = yield call([api, api.get], `${definitionPath(definitionId)}/settings`);
        yield put(actions.getDuplicateSearchSettingsSuccess(result.data));
    } catch (error) {
        yield put(actions.getDuplicateSearchSettingsFailure(definitionId, errorHandler(error, "Get", "duplicate search settings")));
    }
}

export function* setDuplicateSearchBirthRequest(api, action) {
    const { definitionId, birthEnabled } = action.params;
    try {
        const result = yield call([api, api.put], `${definitionPath(definitionId)}/birth`, { birthEnabled });
        yield put(actions.setDuplicateSearchBirthSuccess(result.data));
    } catch (error) {
        // errorHandler keeps the service's own message (another search has it, no golden dataset).
        yield put(actions.setDuplicateSearchBirthFailure(definitionId, errorHandler(error, "Update", "golden record creation")));
    }
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_DUPLICATE_SEARCH_SETTINGS_REQUEST, getDuplicateSearchSettingsRequest, api);
    // Every change runs to its end: one search's change never cancels another's.
    yield takeEvery(actions.SET_DUPLICATE_SEARCH_BIRTH_REQUEST, setDuplicateSearchBirthRequest, api);
}
